module.exports = __webpack_public_path__ + "img/gys_22@2x.6fc0ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_22@2x.png
// module id = TFlx
// module chunks = 0